import React, { useEffect, useState } from 'react';
import EnglishText from '../../Translations/en-US';
import SpanishText from '../../Translations/es-MX';

import ImageCollab1 from '../../assets/TJEvent.png'
import ImageCollab2 from '../../assets/PochaCrew.jpg'
import TarjetaVerdePic from '../../assets/tarjeta-verde-know-your-rights-mexico.svg'
import PochaMap from '../../assets/PochaMap.svg'

import './index.css'

export const KnowYourRights = () => {
    const [language, setLanguage] = useState('en-US')
    const [translation, setTranslation] = useState(EnglishText)
    const [showQuestion, setShowQuestion] = useState(null)

    useEffect(() => {
        document.title = "Tarjeta Verde: Know Your Rights in Mexico";
        document["apple-touch-icon"] = "https://www.odamexico.org/tarjeta-verde-know-your-rights-mexico.png"
    }, []);

    useEffect(() => {
        setTranslation(language === 'es-MX' ? SpanishText : EnglishText)
    }, [language]);

    return (<>
        <div className="KnowYourRightsHeader" id="tarjeta-verde-conoce-tus-derechos-mexico">
            <section className="section v2-banner">

            <div className="container">
                <div className="v2-banner-wrapper">
                    <div className="v2-banner-title-wrap">
                        <h1 className="v2-banner-title">{translation.title}</h1>
                        <div className="language-translation-btn-wrapper">
                        <button type="button" onClick={() => setLanguage('en-US')} className={`primary-button w-inline-block mg-sides-1-rem ${language === 'en-US' ? '' : 'color-white'}`}>
                            <div className="primary-button-text" > English </div>
                        </button>
                        <button type="button" onClick={() => setLanguage('es-MX')} className={`primary-button w-inline-block mg-sides-1-rem ${language === 'es-MX' ? '' : 'color-white'}`}>
                            <div className="primary-button-text" > Español </div>
                        </button>
                    </div>

                    </div>
                    <div className="v2-banner-grid">
                        <div className="v2-banner-card">
                            <div className="v2-banner-card-contant">
                                <div className="v2-banner-info-wrap">
                                <p className="section-details color-aquamarine mg-bottom-3-75-rem">
                                        { translation.subtitle}
                                    </p>
                                    <h2 className="v2-banner-info">{translation.blurb}</h2>
                                    <div className="button-wrapper">
                                        <a href={translation.donate.link} target="_blank" className="primary-button w-inline-block color-white" rel="noreferrer">
                                            <div className="primary-button-text" >{translation.donate.title}</div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="v2-banner-video-wrap">
                            <img className="hero-image-card" src={PochaMap} alt={`Otros Dreams en Accion Pocha House returnee and deportee community migration map`} />
                        </div>
                    </div>
                </div>
            </div>
            </section>

            <section className="section features">
                <div className='container'>
                <div className="features-wrapper for-responsive">
                    <div className="features-contant-wrap">
                        <div className="features-flex-wrap">
                            <div className="feature-image-text-wrap">
                                <div className="features-video-wrap redius-0-rem for-responsive">
                                    <img className="image-card" src={TarjetaVerdePic} alt={`Otros Dreams en Acción (ODA) ${translation.campaignName}: Know your rights for Deported and returned migrants to mexico`} />
                                </div>
                            </div>
                        <div className="features-card">
                            <div className="features-card-contant">
                                <div className="section-mini-title-wrap">
                                    <div className="section-mini-title-flex">
                                        <div className="section-title-dot color-white"></div>
                                        <div className="section-mini-title color-white">{translation.printTitle}</div>
                                    </div>
                                </div>
                                <h2 className="section-title color-white mg-bottom-1-875-rem for-responsive">{translation.campaignName}</h2>
                                <p className="section-details color-white mg-bottom-3-75-rem">{ translation.description } <br/><br/> { translation.description2 } </p>
                                <div data-current="Tab 2" data-easing="ease" data-duration-in="300" data-duration-out="100" className="collaborator-tabs w-tabs">
                                    <div className="collaborator-tabs-menu w-tab-menu" role="tablist">
                                        {translation.print.map((lang) => (
                                            <a
                                                className="collaborator-tab-link w-inline-block w-tab-link w--current "
                                                href={lang.link}
                                                target="_blank"
                                                rel="noreferrer"
                                                key={lang.language}
                                            >
                                                <div className="collaborator-tab-contant-wrap">
                                                    <div className="collaborator-tab-header-wrap">
                                                        <div className="features-number-question">

                                                            <div className="print-option-wrap">
                                                                <h3 className="print-option">{lang.language}:  {lang.fileName}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

                </div>
            </section>
            <section className='section values'>
            <div className="container">
                <div className="section-title-wrap max-width-50-rem">
                    <div className="section-mini-title-wrap">
                        <div className="section-mini-title-flex">
                            <div className="section-title-dot"></div>
                            <div className="section-mini-title">{translation.about.subtitle}</div>
                        </div>
                    </div>
                    <h2 className="section-title">{translation.about.title}</h2>
                </div>
                <div className="values-contant-wrap">
                    <div className="values-grid">
                        <div className="values-card">
                            <div className="values-card-info-title-wrap">
                                <div className="values-card-info-wrap">
                                    <div className="values-card-info">{translation.about.objective.title}</div>
                                </div>
                                <h3 className="values-card-title">{translation.about.objective.tool}</h3>
                            </div>
                            <div className="values-details-tag-wrap">
                                {Object.values(translation.about.objective.points).map((point) => (
                                    <p key={`obj-${point}`} className="values-details">- {point}</p>
                                ))}
                            </div>
                            <div className="values-details-tag-wrap">
                                <h3 className="values-card-title">{translation.about.objective.to}</h3>

                                <div className="values-details-wrap">
                                        {Object.values(translation.about.objective.toPoints).map((point) => (
                                            <p key={`to-${point}`} className="values-details">- {point}</p>
                                        ))}
                                    </div>

                            </div>
                        </div>
                        <div className="values-card dark-cyan">
                            <div className="values-card-info-title-wrap">
                                <div className="values-card-info-wrap">
                                    <div className="values-card-info white">{translation.about.howToUse.title}</div>
                                </div>
                                <h3 className="values-card-title white">{translation.about.howToUse.subtitle}</h3>
                            </div>
                            <div className="values-details-tag-wrap">
                                <div className="values-details-wrap">
                                    <p className="values-details white">- <strong>{translation.about.howToUse.usa.subtitle}</strong> {translation.about.howToUse.usa.description} <br/>{translation.about.howToUse.usa.description2}</p>
                                </div>
                                <div className="values-details-wrap">
                                    <p className="values-details white">- <strong>{translation.about.howToUse.mexico.subtitle}</strong> {translation.about.howToUse.mexico.description} <br/><br/> {translation.about.howToUse.mexico.description2}</p>
                                </div>
                                <a className="home-banner-print-text" href={translation.print[language === "es-MX" ? 0 : 1].link} aria-label="Imprimir PDF Tarjeta Verde conoce tus derechos en México para personas deportadas y retornadas" target="_blank" rel="noreferrer">
                                    <img className="about-more-image card-image" src={translation.about.howToUse.image} alt={`Deportee and Returnee: ${translation.campaignName}`} />
                                </a>

                            </div>
                        </div>
                        <div className="values-card">
                            <div className="values-card-info-title-wrap">
                                <div className="values-card-info-wrap">
                                    <div className="values-card-info">{translation.about.callToAction.title}</div>
                                </div>
                                <h3 className="values-card-title">{translation.about.callToAction.subtitle}</h3>
                            </div>
                            <div className="values-tag-wrap">
                                    {Object.values(translation.about.callToAction.howToHelp).map((point) => (
                                        <div key={`how to help-${point}`} className="single-values-tag">
                                            <div className="values-tag-flex-wrap">
                                                <div className="values-tag-dot"></div>
                                                <div className="values-tag-info">{point}</div>
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            <div className="values-details-tag-wrap">
                                <p className="values-details">{translation.about.callToAction.whoCanJoin} </p>
                            </div>
                            <div className="button-wrapper">
                                <a href={translation.mediaKit.link} target="_blank" className="primary-button w-inline-block" rel="noreferrer">
                                    <div className="primary-button-text" >{translation.mediaKit.title}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="button-wrapper">
                        <a href={translation.donate.link} target="_blank" className="primary-button w-inline-block color-white" rel="noreferrer">
                            <div className="primary-button-text" >{translation.donate.title}</div>
                        </a>
                    </div>

            </div>
            </section>

            <section className="section about-more">
                <div className="container">
                    <div className="about-more-contant-wrap">
                        <div className="about-more-left-wrap">
                            <div className="about-more-image-wrap">
                                <img src={ImageCollab2} loading="lazy" alt=" Otros Dreams en Acción (ODA) Pocha House Crew Community Organizing Against Borders" className="about-more-image" />
                            </div>
                        </div>
                    <div className="about-more-middle-wrap">
                        <div className="about-more-contant">
                            <div className="section-mini-title-wrap">
                                <div className="section-mini-title-flex">
                                    <div className="section-title-dot"></div>
                                    <div className="section-mini-title">{translation.partners.title}</div>
                                </div>
                            </div>
                            <h3 className="about-more-details">{translation.partners.description}</h3>
                            <div className="button-wrapper">
                                <a href={translation.callToAction.link} target="_blank" className="primary-button w-inline-block" rel="noreferrer">
                                    <div className="primary-button-text" >{translation.callToAction.title}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="about-more-right-wrap">
                        <div className="about-more-image-wrap">
                            <img src={ImageCollab1} loading="lazy" alt="Otros Dreams en Acción (ODA) Pocha House Pop-up Tijuana Deportee Welcoming Center" className="about-more-image"/>
                        </div>
                    </div>
                </div>
                <div className="about-more-counter-wrap">
                    <div className="about-more-counter-grid" >
                        {translation.partners.list.map((org) => (
                            <div key={`${org.title}${org.about}`} className="about-more-counter-card">
                                <div className="about-more-counter">
                                    <h2 className="about-more-number">{org.title}</h2>
                                </div>
                                <div className="about-more-counter-info-wrap">
                                    <div className="about-more-counter-info">{org.about}</div>
                                </div>
                                <div className="values-tag-wrap">
                                    {Object.keys(org.socials).map((social) => (<>
                                        <a key={`contact-${social}`} href={org.socials[social]} className="single-values-tag">
                                            <div className="values-tag-flex-wrap">
                                                <div className="values-tag-info">{social}</div>
                                            </div>
                                        </a>
                                    </>))}
                                </div>
                                <img src={org.logo} loading="lazy" alt={org.title} className='logo-sm-right' />
                                <div className="about-more-circle"></div>
                            </div>
                        ))}
                    </div>
                </div>
                </div>
            </section>

            <section className="section faq">
                <div className="container">
                    <div className="faq-wrapper">
                        <div className="faq-flex-wrap">
                            <div className="faq-left-wrap transformation-animation1" >
                                <h2 className="section-title">{translation.faq.subtitle}</h2>
                            </div>
                            <div className="faq-right-wrap">
                                {translation.faq.questions.map((question, tab) => (<>
                                    <div key={`question-${tab}`}  data-current={`question-${tab}`} data-easing="ease" data-duration-in="300" data-duration-out="100" className="faq-accordion-tabs w-tabs mg-bottom-2-rem">
                                        <div className="faq-accordion-wrapper w-tab-menu" role="tablist">
                                            <button
                                                data-w-tab={`question-${tab}`}
                                                className={`single-faq-accordion-wrap w-inline-block w-tab-link transformation-animation1 ${showQuestion === tab ? ' w--current' : ''}`}
                                                onClick={() => setShowQuestion(tab)}
                                                id="w-tabs-1-data-w-tab-0" role="tab"
                                                aria-controls="w-tabs-1-data-w-pane-0" aria-selected="false"
                                                tabindex={tab}>
                                                <div className="faq-accordion-contant">
                                                    <div className="faq-accordion-question-wrap">
                                                        <h3 className="faq-question">{question.question}</h3>
                                                        <div className="faq-icon-wrapper" >
                                                            <div className={`faq-icon ${showQuestion === tab ? 'hide' : ''}`}>+</div>
                                                            <div className={`faq-icon ${showQuestion === tab ? '' : 'hide'}`}>--</div>
                                                        </div>
                                                    </div>
                                                    <div className={`faq-accordion-answer-wrap ${showQuestion === tab ? '' : 'hide'}`} style={{width: '100%'}}>
                                                        <div className="">
                                                        {question.answers.map((answer, idx) =>
                                                            typeof answer !== "string" ? (
                                                            <p key={idx} className="faq-answer">
                                                                {answer.text}
                                                                <a className="faq-answer faq-link" href={answer.url} target="_blank" rel="noreferrer" > <strong>{answer.prompt}</strong> </a>
                                                            </p>) :
                                                            (<p key={idx} className="faq-answer">{answer} </p>)
                                                        )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </>))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </>);
}

export default KnowYourRights;